import React, { useState } from 'react';
import Div100vh from "react-div-100vh";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { chatHelpMessage, trackBtnClick, inviteFriends } from "@/lib/helper";
import CustomDrawer from "../common/drawer";
import TermsAndConditions from "./TermsAndConditions";
import ProfileIcon from "@/assets/icons/user-profile.svg";
import GoBackButton from "../common/buttons/GoBackButton";
import EllipseGrey from "@/assets/images/grey-ellipse.svg";
import {
  MessageCircleCode,
  CircleHelp,
  LogOut,
  LucideShare2,
  ReceiptText
} from "lucide-react";

const Profile = () => {
  const navigate = useNavigate();
  const [howItWorks, setHowItWorks] = useState(false);
  // const userData = useRecoilValue(userDataAtom);
  const [userData, setUserData] = useRecoilState(userDataAtom);

  const handleFAQClick = () => {
    trackBtnClick("FAQ", "Home Page");
    navigate("/faq");
  };

  const handleTnCClick = () => {
    setHowItWorks((prevState) => !prevState);
  };

  // const handleShareClick = () => {
  //   inviteFriends(userData?.referral_code);
  // };

  const handleShareClick = async () => {
    const shareMessage = `Hey! I'm using Circle App and I think you should too.
    
    Sign up using my referral code *${userData?.referralCode}* and get rewards!
    
    Link: https://join.circlepe.in?rf_code=${userData?.referralCode}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Get Rewards!",
          text: shareMessage,
          url: `https://join.circlepe.in?rf_code=${userData?.referralCode}`, // You can customize this URL
        });
        console.log("Referral shared successfully!");
      } catch (error) {
        console.error("Error sharing referral:", error);
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      const shareUrl = `whatsapp://send?text=${encodeURIComponent(shareMessage)}`;
      window.open(shareUrl, "_blank");
    }
  };

  const handleLogoutClick = () => {
    localStorage.clear();
    setUserData({});
    navigate("/");
  };

  const handleDeleteClick = () => {
    // localStorage.removeItem("SIGNUP_TOKEN_CP");
    // setUserData({});
    navigate("/bye");
  };

  const content = [
    {
      icon: <MessageCircleCode />,
      text: "Chat",
      onClick: chatHelpMessage,
    },
    {
      icon: <CircleHelp />,
      text: "FAQ's",
      onClick: handleFAQClick,
    },
    {
      icon: <ReceiptText />,
      text: "T&Cs",
      onClick: handleTnCClick,
    },
    {
      icon: <LucideShare2 />,
      text: "Share",
      onClick: handleShareClick,
    },
    {
      icon: <LogOut />,
      text: "Logout",
      onClick: handleLogoutClick,
    },
  ];

  return (
    <Div100vh className="flex flex-col p-6 justify-between overflow-y-scroll">
      <div className="flex flex-col pt-6">
        {/* <GoBackButton customBackSubmit={()=>{
          // alert("ssssss")
          navigate("/home",{state:{shouldLoad:false,pass:true}})
        }}/> */}

        <div className="flex flex-col justify-center items-center gap-2">
          <img src={ProfileIcon} alt="profile-icon" />
          <div className="text-center">
            <span className="text-[#929292] text-xs">Hello,</span>
            <div className="text-primary-200 text-lg font-medium">
              {[userData?.firstName, userData?.middleName, userData?.lastName]
                .filter(Boolean)
                .join(" ")}
            </div>
            <span className="text-[#929292] text-2xs">{userData?.phone}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        {content.map((c, index) => (
          <button
            key={index}
            className="flex items-center mb-4 gap-5 border-b-2 border-black-light p-2"
            onClick={c.onClick}
          >
            <div className="flex rounded-full h-8 w-8 bg-black-light p-2 justify-center items-center">
              {c.icon}
            </div>
            <div className="ml-2 text-sm text-primary-100">{c.text}</div>
          </button>
        ))}
      </div>

      <CustomDrawer
        isOpen={howItWorks}
        onClose={() => setHowItWorks(false)}
        removePadding
      >
        <TermsAndConditions setOtpDrawer={setHowItWorks} />
      </CustomDrawer>

      <div className="flex justify-center gap-1">
        <button
          className="text-3xs text-primary-400 underline"
          onClick={handleDeleteClick}
        >
          Delete Account
        </button>
        <img src={EllipseGrey} alt="dot" className="scale-50" />
        <p className="text-3xs text-primary-400">
          Copyright @2024, All Rights Reserved
        </p>
      </div>
    </Div100vh>
  );
};

export default Profile;
